<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 2),
                        href: meta.links.survey_index,
                    },
                    {
                        name: $tc('messages.survey_reports', 2),
                        href: meta.links.survey_records_index,
                    },
                    {
                        name: survey.title,
                        href: null,
                    },
                    {
                        name: report.date_display,
                        href: null,
                    },
                ]"
            />
        </template>
        <div>
            <SurveyReport :survey="survey" :report="report" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SurveyReport from './partials/SurveyReport.vue';

export default {
    components: {
        SurveyReport,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'survey', 'report'],
};
</script>
